import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const AuthCallback = () => {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? match[1] : null;
    if (!sessionId) { navigate("/login"); return; }
    (async () => {
      try {
        const res = await api.post("/auth/session", { session_id: sessionId });
        setUser(res.data.user);
        window.history.replaceState(null, "", "/admin");
        navigate("/admin", { state: { user: res.data.user } });
      } catch {
        navigate("/login");
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen bg-f2b-black flex items-center justify-center">
      <div className="text-center">
        <div className="w-10 h-10 border-2 border-f2b-cyan border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-white/60">Connexion en cours…</p>
      </div>
    </div>
  );
};

export default AuthCallback;
